/**
 * 菜单
 */

var platform = () =>import ( /* webpackChunkName: "platform" */ `@/page/statistics/platform.vue`)
var index = () =>import ( /* webpackChunkName: "index" */ `@/page/statistics/index.vue`)
var index2 = () =>import ( /* webpackChunkName: "index" */ `@/page/statistics2/index.vue`)
var indexV2 = () =>import ( /* webpackChunkName: "index" */ `@/page/statistics-v2/index.vue`)
export default [
  {
    path: '/index',
    name: '平台',
    component: indexV2,
  },
  {
    path: '/index2',
    name: '平台',
    component: index2,
  }
]
